// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"256":"2bd2328c","512":"2bd2328c","977":"6bafde4b"}[chunkId] + ".chunk.css";
};